import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';

import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-sidebar-transfer-indicator',
  templateUrl: './sidebar-transfer-indicator.component.html',
  styleUrls: ['./sidebar-transfer-indicator.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule, MatDividerModule],
})
export class SidebarTransferIndicatorComponent implements OnChanges, OnDestroy, OnInit {
  @Input() isExpanded: boolean = false;
  @Input() locatorStatus: {
    remaining: number;
    processed: number;
    locatorLog: { locator: string; success: boolean }[];
  } = {
    remaining: 0,
    processed: 0,
    locatorLog: [],
  };

  @Output() toggleTooltip = new EventEmitter<{
    event: MouseEvent;
    template: TemplateRef<unknown>;
  }>();

  hasActiveTransfers: boolean = false;
  private activityCheckInterval: any = null;
  private lastActivityTime: number = 0;
  private readonly activityTimeout = 1000;
  private previousProcessed = 0;
  private previousRemaining = 0;
  private ignoreNextCheck = false;

  ngOnInit(): void {
    this.activityCheckInterval = setInterval(() => this.checkForInactivity(), 500);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isExpanded']) {
      return;
    }

    if (changes['locatorStatus'] && changes['locatorStatus'].currentValue) {
      const status = changes['locatorStatus'].currentValue;

      const hasNewActivity =
        status.remaining !== this.previousRemaining || status.processed !== this.previousProcessed;

      if (hasNewActivity) {
        this.lastActivityTime = Date.now();
        this.hasActiveTransfers = true;
      }

      this.previousRemaining = status.remaining;
      this.previousProcessed = status.processed;
    }
  }

  private checkForInactivity(): void {
    if (this.ignoreNextCheck) {
      this.ignoreNextCheck = false;
      return;
    }

    if (this.hasActiveTransfers) {
      const now = Date.now();
      const timeSinceLastActivity = now - this.lastActivityTime;

      if (timeSinceLastActivity >= this.activityTimeout) {
        this.hasActiveTransfers = false;
      }
    }
  }

  ngOnDestroy(): void {
    if (this.activityCheckInterval) {
      clearInterval(this.activityCheckInterval);
      this.activityCheckInterval = null;
    }
  }

  onToggleTooltip(event: any, template: TemplateRef<unknown>): void {
    this.toggleTooltip.emit({ event, template });
  }
}
